import images from "./images";

let Developement = [
  {
    title: "NCR Management Website",
    description:
      "A Web app that helps in management of Non-Conformance Report(NCR) for Fluid Control company for multiple vendor supplies. Create NCR form, reject NCR form, resend if not satisfied with answers provided by vendor, view previously filled NCR's on dashboard. Fill and view active and rejected NCR's from product receiver",
    ProjectLink: "",
    codeLink: "https://github.com/prathmeshd001/NCR",
    imageUrl: images.about01,
  },
  {
    title: "Shopping Cart",
    description:
      "A shopping Cart client webapp where one can add remove items and their quentities from: -Store -Cart",
    ProjectLink: "https://psd-shopping-cart.netlify.app/",
    codeLink: "https://github.com/prathmeshd001/shopping-cart",
    imageUrl: images.shoppingcart,
  },
  {
    title: "Note Taking App",
    description:
      "A advance note taking app with create, edit and delete notes feature. Search filter for notes by tag and note title. All note data is stored in local Storage.",
    ProjectLink: "https://note-taking-app-psd.netlify.app/",
    codeLink: "https://github.com/prathmeshd001/note-taking-app",
    imageUrl: images.noteapp,
  },
  {
    title: "Tenzies-Dice Game",
    description:
      "Roll 10 given dice until you win. Roll until all dice are the same. Click each die to freeze it at its current value between rolls. Rolling will give non-freezed dices random number from 1 to 6",
    ProjectLink: "https://psd-tenzi-game.netlify.app/",
    codeLink: "https://github.com/prathmeshd001/Tenzies-Dice",
    imageUrl: images.tenzi,
  },
  {
    title: "ChatAi",
    description:
      "Chat bot created using OpaeAi api bot that answers mostly Programming questions",
    ProjectLink: "https://chat-ai-programming.netlify.app/",
    codeLink: "https://github.com/prathmeshd001/ChatAi",
    imageUrl: images.chatai,
  },
  {
    title: "Admin Dashboard",
    description:
      "Admin Dashboard A Admin Dashboard full stack webapp with dummy data having different charts and tables about customers and products details.",
    ProjectLink: "https://admindashboardfrontend.onrender.com/",
    codeLink: "https://github.com/prathmeshd001/admin-dashboard",
    imageUrl: images.admindashboard,
  },
];

export default Developement;
